const mergeIdentifierIntoGtmProps = (gtm = {}, identifierName, identifierValue) => (
  Object.keys(gtm).reduce((copy, key) => ({
    ...copy,
    [key]: gtm[key] && gtm[key].replace(
      new RegExp(`{{\\s*${identifierName}\\s*}}`),
      identifierValue,
    ),
  }), {})
);

const makeItemLink = (item, { gtm, ...rest }, itemIdentifierName) => ({
  ...item.link,
  ...rest,
  gtm: mergeIdentifierIntoGtmProps(gtm, itemIdentifierName, item[itemIdentifierName]),
});

export default makeItemLink;
